/* Quick add (bag icon) next to the wishlist heart on every product card. The click itself is handled by enzo-fixes.js. */
(() => {
  const SOLD_OUT = /esaurit|sold out|ausverkauft|épuisé|epuise|agotado|esgotado/i;
  const LABELS = { it: 'Aggiungi al carrello', en: 'Add to cart', de: 'In den Warenkorb', fr: 'Ajouter au panier', es: 'Añadir al carrito', pt: 'Adicionar ao carrinho' };
  const label = LABELS[(document.documentElement.lang || 'it').slice(0, 2)] || LABELS.it;
  const BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5.5 8.5h13l-1 11.5h-11z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/></svg>';

  function addBags() {
    document.querySelectorAll('card-product[data-handle] .enzo-card-actions:not([data-enzo-bag])').forEach(actions => {
      actions.dataset.enzoBag = '1';
      if (actions.querySelector('.enzo-quick-add')) return;
      const card = actions.closest('card-product');
      const soldOut = Array.from(card.querySelectorAll('.badge')).some(badge => SOLD_OUT.test(badge.textContent));
      if (soldOut) return;
      const title = ((card.querySelector('.card-product__title') || {}).textContent || '').trim();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'enzo-card-btn enzo-quick-add';
      button.dataset.handle = card.dataset.handle;
      button.innerHTML = BAG;
      button.setAttribute('aria-label', title ? `${label}: ${title}` : label);
      actions.append(button);
    });
  }

  let queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; addBags(); });
  }
  function start() {
    queue();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && node.classList.contains('enzo-card-actions') || (node.nodeType === 1 && node.querySelector && node.querySelector('.enzo-card-actions:not([data-enzo-bag])'))))) queue();
    }).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queue);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
